// G插件端初始化
import StorageUtils from './core/storageUtils'
import { GetGcsAddinInfo, GetEquipmentSelectionArguments, Init } from './core/gcsUtils'

export const initGcs = async function({ Vue, Store }, { softwareCode, softwareVersion, language }) {
  Init()
  // 获取edition信息，协同版或单机版
  const { data } = await GetGcsAddinInfo()
  const edition = data ? data.edition : 'collaboration'
  const fromEntrance = data.fromEntrance
  // 获取预设参数
  const isSelectingEquipment = fromEntrance === 'ENT_GMEP_EQUIPMENT_SELECTION'
  const res = isSelectingEquipment && await GetEquipmentSelectionArguments()
  const selectionObj = {
    seltectdObjs: res.data
  }
  const curveSearchValues = []
  const propertySearchValues = []
  return new Promise((resolve) => {
    StorageUtils.sessionStorage.set('softwareCode', softwareCode)
    StorageUtils.sessionStorage.set('softwareVersion', softwareVersion)
    StorageUtils.sessionStorage.set('language', language)
    Store.commit('setSoftwareCode', softwareCode)
    Store.commit('setSoftwareVersion', softwareVersion)
    Store.commit('setLanguage', language)
    Store.commit('setEdition', edition)
    Store.commit('setFromEntrance', fromEntrance)
    Store.commit('setIsSelectingEquipment', isSelectingEquipment)
    Store.commit('fastSearch/setCurveSearchValues', curveSearchValues)
    Store.commit('setSelectionParams', selectionObj)
    // 处理列表页筛选条件组件中所需的初始值
    Store.commit('fastSearch/setPropertySearchValues', propertySearchValues)
    resolve()
  })
}
